import { useId, useState } from "react";

import { TextArea, Toast } from "@monta/design-system";
import { examResultCommentInsertOrUpdate } from "../../services";
import { auth } from "#/utils";
import { UsersTypeEnum } from "#/constants";
import type Props from "./types";

const MsgBox = ({ comment, studentId, takingDetailId }: Readonly<Props>) => {
  const [val, setVal] = useState("");
  const textAreaId = useId();
  const user = auth.useAuth();

  const isB2B =
    user?.typeId === UsersTypeEnum.ADVISOR ||
    user?.typeId === UsersTypeEnum.TEACHER ||
    user?.typeId === UsersTypeEnum.SCHOOLOPERATOR ||
    user?.typeId === UsersTypeEnum.OPERATOR ||
    // TODO: remove this after fix enum ts error
    // @ts-expect-error enum ts error
    user?.typeId === UsersTypeEnum.ADVISOR ||
    user?.typeId === UsersTypeEnum.ADMINISTRATOR ||
    user?.typeId === UsersTypeEnum.آموزشگاه ||
    user?.typeId === UsersTypeEnum.مرکز_مشاوره ||
    user?.typeId === UsersTypeEnum.DEAN ||
    user?.typeId === UsersTypeEnum.SUPER_USER;

  const { mutate, isLoading } = examResultCommentInsertOrUpdate.useMutation();

  const onSubmitMsg = () => {
    mutate(
      {
        body: {
          comment: val.trim(),
          studentId,
          takingDetailId
        }
      },
      {
        onSuccess: () => {
          Toast.success({ message: "پیام شما به دانش آموز با موفقیت ثبت شد." });
        }
      }
    );
  };

  return (
    <div className="flex flex-col w-full gap-4 mt-4">
      {!isB2B && (
        <p
          className={`${comment?.length ? "font-semibold text-sm leading-8" : "text-center text-neutral-500"}`}
        >
          {comment?.length ? comment : "پیامی برای شما ثبت نشده است."}
        </p>
      )}

      {isB2B ? (
        <>
          <TextArea
            id={textAreaId}
            aria-label="پیام استاد/مشاور"
            aria-describedby="پیام استاد/مشاور"
            className="w-full"
            placeholder="لطفا یادداشت و دیدگاه خود را برای دانش آموز بنویسید..."
            value={val}
            onChange={(e) => setVal(e.currentTarget.value)}
          />

          <button
            onClick={onSubmitMsg}
            type="button"
            className={`w-[160px] mr-auto h-12 rounded-2 flex items-center justify-center text-white ${!val.length || isLoading ? "bg-[#FF6A0070] cursor-not-allowed" : "bg-[#FF6A00]"}`}
            disabled={!val.length || isLoading}
            aria-disabled={!val.length || isLoading}
          >
            {isLoading ? "در حال ذخیره..." : "ذخیره"}
          </button>
        </>
      ) : null}
    </div>
  );
};

export default MsgBox;
